var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"miner-coin-container"},[_c('div',{staticClass:"miner-details-coin d-flex align-center"},[_c('img',{staticClass:"mr-3",attrs:{"width":"22px","src":_vm.getImg(_vm.coin.img)}}),_c('p',[_vm._v(_vm._s(_vm.coin.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }